/* Malichus encyclopedia - loader for later correction files.
   The template's script list is shared with another work stream, so every
   change to it is a change to a file two teams edit. This loader lets further
   correction files be added by rewriting this one file instead. Anything
   listed here is loaded after the app, so it may only patch data that the
   page reads at render time - not data read once at module start. */
(function(){
if(window.__mzext)return;window.__mzext=1;

var FILES=[
 'mz-h-bo1.js',
 'mz-h-brg.js',
 'mz-h-brimg.js',
 'mz-h-ref1.js',
 'mz-h-sd9.js',
 'mz-h-rv9.js',
 'mz-h-rpmov.js',
 'mz-h-rp9.js',
 'mz-h-rp10.js',
 'mz-h-pd.js',
 'mz-h-cal9.js',
 'mz-h-hs9.js',
 'mz-h-tb9.js',
 'mz-h-rt9.js',
 'mz-h-lg9.js',
 'mz-h-cc9.js',
 'mz-h-hv9.js',
 'mz-h-gu9.js',
 'mz-h-db9.js',
 'mz-h-fn9.js',
 'mz-h-ch9.js',
 'mz-h-mp9.js',
 'mz-h-sk9.js','mz-h-lo9.js','mz-h-lo9t.js','mz-h-an9.js','mz-h-au9.js','mz-h-cx10g.js','mz-h-cx10r.js','mz-h-cx10t.js','mz-h-cx10.js','mz-h-cx9t.js','mz-h-tt9.js','mz-h-rel9.js','mz-h-era1.js','mz-h-name1.js','mz-h-wv1.js','mz-h-wv2.js','mz-h-wv3.js','mz-h-sad1.js','mz-h-sad2.js','mz-h-sa1.js','mz-h-tl1.js','mz-h-cl1.js','mz-h-vc1.js','mz-h-pu1.js','mz-h-fx1.js','mz-h-pw1.js','mz-h-ux1.js','mz-h-fx2.js','mz-h-fx3.js','mz-h-fx4.js','mz-h-fx5.js','mz-h-dict.js','mz-h-mk.js','mz-h-mkq.js','mz-h-tx1.js','mz-audit-20261014.js','mz-h-founders-20261014.js'
];

var base='',q='',REV='audit-20261014-11';
try{
 var s=document.querySelector('script[src*="mz-h-ext"]');
 if(s){base=s.src.replace(/mz-h-ext\.js.*$/,'');var m=s.src.match(/\?[^#]*/);q=m?m[0]:''}
}catch(e){}
if(!base)return;

FILES.forEach(function(f){
 try{
  var el=document.createElement('script');
  el.src=base+f+(q?q+'&':'?')+REV;el.defer=true;el.async=false;
  document.head.appendChild(el);
 }catch(e){}
});

})();
